import { Box, Grid } from '@mui/material';
import KpiCard from '../../../../components/ui/kpiCard';

export function AudienceKpis() {
  return (
    <Box>
<Grid container spacing={3} mb={4}>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title="Acheteurs uniques" value="4 230" trend="+12%"  />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title="Nouveaux clients" value="38%" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title="Clients récurrents" value="62%" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title="Abonnés newsletter" value="45%" />
      </Grid>
    </Grid>
    </Box>
    
  );
}
